import React, { useEffect, useState } from 'react';
import './FAQ.css';

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "Como salvo meus QRCodes?",
      answer: "Todos os QRCodes gerados e baixados ficam salvos automaticamente no seu perfil após o login. Você pode acessar seu histórico completo na área 'Minha Conta', onde poderá visualizar, baixar novamente ou gerenciar todos os seus QR Codes criados."
    },
    {
      question: "Como funciona a assinatura?",
      answer: "Ao assinar um plano PRO ou Business, você desbloqueia recursos avançados como QR Codes ilimitados, personalização avançada, templates exclusivos e suporte prioritário. Sua assinatura é gerenciada através do Mercado Pago e pode ser cancelada a qualquer momento."
    },
    {
      question: "Quais tipos de QR Code posso criar?",
      answer: "Nossa plataforma suporta mais de 12 tipos de QR Codes: URL, E-mail, SMS, Telefone, WhatsApp, Wi-Fi, vCard (cartão de visita), Texto, Localização, Evento, PayPal e PIX. Cada tipo possui campos personalizados para facilitar a criação."
    },
    {
      question: "Posso personalizar o design do QR Code?",
      answer: "Sim! Você pode personalizar cores, formas dos módulos (quadrados, pontos, arredondados), adicionar logo no centro, escolher entre diversos templates prontos e ajustar gradientes. Para personalizações avançadas, considere nosso plano PRO."
    },
    {
      question: "Os QR Codes gerados têm limite de escaneamentos?",
      answer: "Não! Os QR Codes são gerados localmente no seu navegador e não possuem nenhum limite de escaneamentos. Eles funcionarão indefinidamente, pois o conteúdo é embutido diretamente no código."
    },
    {
      question: "Como faço um donativo ou upgrade de plano?",
      answer: "Basta acessar a página 'Planos' no menu superior, escolher o plano desejado (PRO ou Business) e seguir o processo de pagamento via Mercado Pago. Você também pode fazer donativos únicos para apoiar o projeto."
    },
    {
      question: "Qual a diferença entre os planos Free, PRO e Business?",
      answer: "Plano Free: até 15 QR Codes sem expiração. Plano PRO: até 100 QR Codes sem expiração. Plano Business: QR Codes ilimitados, sem expiração, e possibilidade de criar até 10 sub-usuários para sua equipe."
    },
    {
      question: "Posso usar o QRCodeXpress offline?",
      answer: "Sim! Nossa plataforma é uma PWA (Progressive Web App), permitindo que você instale no seu dispositivo e use offline para gerar QR Codes. O histórico e sincronização exigem conexão com internet."
    },
    {
      question: "Como adiciono uma logo ao meu QR Code?",
      answer: "Na seção de personalização, clique em 'Adicionar Logo', faça upload da sua imagem (PNG, JPG ou SVG) e ajuste o tamanho. Recomendamos logos quadrados com fundo transparente para melhor resultado."
    },
    {
      question: "Sou admin, como acesso o dashboard administrativo?",
      answer: "Faça login com sua conta de administrador e acesse a opção 'Admin Dashboard' que aparecerá no menu superior. Lá você pode gerenciar usuários, visualizar estatísticas e configurar planos."
    }
  ];

  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer
        }
      }))
    };

    let schemaTag = document.querySelector('#faq-jsonld');
    if (!schemaTag) {
      schemaTag = document.createElement('script');
      schemaTag.setAttribute('id', 'faq-jsonld');
      schemaTag.setAttribute('type', 'application/ld+json');
      document.head.appendChild(schemaTag);
    }

    schemaTag.textContent = JSON.stringify(schema);

    return () => {
      const currentTag = document.querySelector('#faq-jsonld');
      if (currentTag) currentTag.remove();
    };
  }, []);

  return (
    <div className="faq-page-wrapper">
      <div className="faq-container">
        <div className="faq-header">
          <div className="faq-icon">❓</div>
          <h1>Perguntas Frequentes</h1>
          <p className="faq-subtitle">
            Encontre respostas rápidas para as dúvidas mais comuns sobre o QRCodeXpress
          </p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            >
              <div 
                className="faq-question" 
                onClick={() => toggleFAQ(index)}
              >
                <h3>{faq.question}</h3>
                <svg 
                  className="faq-chevron" 
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    d="M7 10l5 5 5-5" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    fill="none"
                  />
                </svg>
              </div>
              <div className="faq-answer">
                <div className="faq-answer-content">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="faq-cta">
          <div className="cta-icon">💬</div>
          <h3>Ainda tem dúvidas?</h3>
          <p>Nossa equipe está pronta para ajudar você!</p>
          <a href="/contato" className="cta-button">
            Entre em Contato
          </a>
        </div>
      </div>
    </div>
  );
}

